<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-point-summary"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickOk()">
                        <img src="@/assets/icon/otp_icon_close@3x.png" />
                    </div>
                    <div>{{lbl.qrcode.summary.text_receive}}</div>
                    <div class="receive-point text-center">
                        <span class="mr-2 point text-bold">{{point | number_format}}</span>
                        <span>
                            <img src="@/assets/icon/reward_icon_coin@3x.png" />
                        </span>
                    </div>
                </div>
                <div class="modal-base-body" v-if="campaign">
                    <div class="special-text">
                        <div class="text-description text-center ">
                            <div v-if="!isMission">
                                <div>และ</div>
                                <div class="wrap-text">
                                    {{campaign.CampaignName}}
                                </div>
                            </div>
                            <div class="wrap-text" v-if="isMission">
                                {{lbl.qrcode.summary.text_success}}
                            </div>
                        </div>
                        <div class="img-description-wrapper">
                            <div class="img-description">
                                <img :src="imageUrl"/>
                            </div>
                        </div>
                        <div class="sub-text-description">
                            {{isMission ? lbl.qrcode.summary.text_check_mission : lbl.qrcode.summary.text_check}}
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-ok-wrapper">
                        <div class="btn-ok" @click="clickOk()">
                           {{lbl.qrcode.summary.btn_next}}
                        </div>
                    </div>
                    <div class="btn-cancel-wrapper">
                        <div class="btn-cancel" @click="clickToPage()">
                           {{lbl.qrcode.summary.btn_history}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import FormHelper from "@/helper/FormHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
/**
 * @property {ProductDescriptionModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "PointSummaryModal",
    props: {
        controller: Object,
        modalId: String
    },
    components: {},
    mixins: [LocaleMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            point: "",
            campaign: null,
            isMission: false,
            busModal: null,
            localePage: {},
            isFirstSave: true,
            errorInfo: [],
            listItem: [],
            imageUrl: null,
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(1);
        this.busModal = this.controller.busModal;
        this.localePage = this.lbl.modalProductList;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickToPage: function(){
            this.hide();
            this.controller.sendCallbackPage({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.point = config.point;
            if(config.campaign){
                var currentTime = new Date().getTime() / 1000;
                this.campaign = config.campaign;
                this.imageUrl = ConfigManager.getBlobUrl() + "/campaigns/" + this.campaign.CampaignId + "?time=" +currentTime
                this.isMission = config.isMission;
            }else{
                this.campaign = null;
                this.imageUrl = null;
            }
            
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";

.img-description-wrapper {
    margin-top: 15px;
    padding: 0px 20px;
    .img-description {
        @include baseRatioImg(66.67%);
        margin-bottom: 25px;
        padding: 0px 20px;
    }
}
.text-description {
    .wrap-text {
        @extend %ellipsis-2;
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-point-summary {
    @extend %modal-base;
    color: $bright-gray;

    .modal-body {
        padding: 25px;

        @include mini-mobile(){
            padding: 10px;
        }
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin: 0;

        .modal-content {
            box-shadow: $box-shadow-bar;
            border-radius: 0;
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            border: 0;

            .modal-base-head {
                color: $bright-gray;
                font-size: 1.2rem;
                text-align: center;

                @include mini-mobile(){
                    padding-top: 10px;
                }

                .modal-base-close {
                    position: absolute;
                    top: -5px;
                    right: 0;

                    @include mini-mobile(){
                        top: 5px;
                        right: 10px;
                    }

                    img {
                        width: 15px;
                    }
                }
            }

            .text-description {
                padding: 10px 0px;
                font-family: $medium;
                font-size: 1.2rem;

                @include mini-mobile(){
                    font-size: 1rem;
                }
            }
            .sub-text-description {
                text-align: center;
                font-size: 1.1rem;

                @include mini-mobile(){
                    font-size: 1rem;
                }
            }
            .receive-point {
                margin-top: 10px;
                .point {
                    color: $pink;
                    font-size: 1.8rem;

                    @include mini-mobile(){
                        font-size: 1.5rem;
                    }
                }
                img {
                    margin-top: -10px;
                    width: 40px;
                    border-radius: 50%;
                    box-shadow: $box-shadow;
                }
            }
            .modal-base-footer {
                padding-top: 25px;

                @include mini-mobile(){
                    padding: 20px 10px 10px;
                    margin: auto;
                }

                .btn-ok-wrapper {
                    margin-bottom: 12px;
                    font-size: 1.2rem;

                    .btn-ok {
                        color: $white;
                        background: $deep-blue;
                        text-align: center;
                        padding: 12px 20px;
                        border-radius: 50px;
                        box-shadow: $box-shadow;
                    }
                }
                .btn-cancel-wrapper {
                    margin-bottom: 10px;
                    font-size: 1.2rem;
                    .btn-cancel {
                        color: $blue-gray;
                        background: $white;
                        text-align: center;
                        padding: 10px 20px;
                        border-radius: 50px;
                        border: solid 2px $blue-gray;
                        box-shadow: $box-shadow;
                    }
                }
            }
        }
        .area-input {
            .wrap-input {
                .label {
                    margin-bottom: 5px;
                }
                .ddl-input {
                    .btn-ddl-input {
                        margin-top: unset;
                    }
                }
            }
        }
    }
}
</style>
